/**
 * The 24 governorates of Tunisia with their ISO 3166-2:TN codes, used for shipping zones and
 * delivery addresses. Names are given in Arabic, French and English; Tunisian (aeb) uses the
 * Arabic names.
 */
export const GOVERNORATES = [
    { code: 'TN-11', ar: 'تونس', fr: 'Tunis', en: 'Tunis' },
    { code: 'TN-12', ar: 'أريانة', fr: 'Ariana', en: 'Ariana' },
    { code: 'TN-13', ar: 'بن عروس', fr: 'Ben Arous', en: 'Ben Arous' },
    { code: 'TN-14', ar: 'منوبة', fr: 'Manouba', en: 'Manouba' },
    { code: 'TN-21', ar: 'نابل', fr: 'Nabeul', en: 'Nabeul' },
    { code: 'TN-22', ar: 'زغوان', fr: 'Zaghouan', en: 'Zaghouan' },
    { code: 'TN-23', ar: 'بنزرت', fr: 'Bizerte', en: 'Bizerte' },
    { code: 'TN-31', ar: 'باجة', fr: 'Béja', en: 'Beja' },
    { code: 'TN-32', ar: 'جندوبة', fr: 'Jendouba', en: 'Jendouba' },
    { code: 'TN-33', ar: 'الكاف', fr: 'Le Kef', en: 'Kef' },
    { code: 'TN-34', ar: 'سليانة', fr: 'Siliana', en: 'Siliana' },
    { code: 'TN-41', ar: 'القيروان', fr: 'Kairouan', en: 'Kairouan' },
    { code: 'TN-42', ar: 'القصرين', fr: 'Kasserine', en: 'Kasserine' },
    { code: 'TN-43', ar: 'سيدي بوزيد', fr: 'Sidi Bouzid', en: 'Sidi Bouzid' },
    { code: 'TN-51', ar: 'سوسة', fr: 'Sousse', en: 'Sousse' },
    { code: 'TN-52', ar: 'المنستير', fr: 'Monastir', en: 'Monastir' },
    { code: 'TN-53', ar: 'المهدية', fr: 'Mahdia', en: 'Mahdia' },
    { code: 'TN-61', ar: 'صفاقس', fr: 'Sfax', en: 'Sfax' },
    { code: 'TN-71', ar: 'قفصة', fr: 'Gafsa', en: 'Gafsa' },
    { code: 'TN-72', ar: 'توزر', fr: 'Tozeur', en: 'Tozeur' },
    { code: 'TN-73', ar: 'قبلي', fr: 'Kébili', en: 'Kebili' },
    { code: 'TN-81', ar: 'قابس', fr: 'Gabès', en: 'Gabes' },
    { code: 'TN-82', ar: 'مدنين', fr: 'Médenine', en: 'Medenine' },
    { code: 'TN-83', ar: 'تطاوين', fr: 'Tataouine', en: 'Tataouine' },
];
export const GOVERNORATE_CODES = GOVERNORATES.map((g) => g.code);
export function isGovernorateCode(value) {
    return typeof value === 'string' && GOVERNORATE_CODES.includes(value);
}
/** Name of a governorate in `locale` (aeb uses the Arabic name). */
export function governorateName(code, locale) {
    const governorate = GOVERNORATES.find((g) => g.code === code);
    if (governorate === undefined)
        return code;
    return locale === 'aeb' ? governorate.ar : governorate[locale];
}
export function governorateNames(code) {
    const governorate = GOVERNORATES.find((g) => g.code === code);
    return governorate === undefined
        ? {}
        : { ar: governorate.ar, fr: governorate.fr, en: governorate.en, aeb: governorate.ar };
}
/**
 * Normalizes a phone number to E.164 ("+21620123456"). Eight digits are read as a Tunisian
 * national number (+216); numbers with a "+" or "00" prefix are kept as international numbers.
 * Spaces, dots and dashes are ignored. Returns null when it cannot be a phone number.
 */
export function normalizePhone(raw) {
    const compact = raw.replace(/[\s.\-()]/g, '');
    let digits;
    if (compact.startsWith('+'))
        digits = compact.slice(1);
    else if (compact.startsWith('00'))
        digits = compact.slice(2);
    else if (/^[0-9]{8}$/.test(compact))
        digits = `216${compact}`;
    else
        return null;
    if (!/^[0-9]{8,15}$/.test(digits))
        return null;
    if (digits.startsWith('216') && digits.length !== 11)
        return null;
    return `+${digits}`;
}
//# sourceMappingURL=tunisia.js.map